/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const WedIcon = createIcon({
  displayName: "WedIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        d="M4.53622 12.9995L1.91406 3.54492H3.41442L5.25639 10.8667H5.34411L7.25994 3.54492H8.74645L10.6623 10.8713H10.75L12.5874 3.54492H14.0923L11.4656 12.9995H10.0298L8.04013 5.91779H7.96626L5.97656 12.9995H4.53622Z"
        fill="currentColor"
      />
    </g>
  )
});
